const licenseBasic = {
  key: "basic",
  name: "BASIC",
  price: "$49",
  providedFeatures: [
    "audience_10k",
    "distribution_internal",
    "distribution_social",
    "license_basic",
    "team_10",
  ],
  uses: [
    "Personal use",
    "Internal use",
    "Social media",
    "Live streaming",
    "Non-profit",
  ],
  conditions: [
    "Audience up to 10,000",
    "Up to 10 employees",
    "Attribution required",
  ],
};

const licensePro = {
  key: "pro",
  name: "PRO",
  price: "$249",
  providedFeatures: licenseBasic.providedFeatures.concat([
    "audience_250k",
    "distribution_private",
    "distribution_public",
    "distribution_reproduction",
    "distribution_software",
    "distribution_training",
    "license_pro",
    "team_50",
  ]),
  uses: [
    "BASIC",
    "+",
    "Public shows",
    "Music on hold",
    "Online courses",
    "Software, video games",
    "CD or DVD reproductions",
  ],
  conditions: [
    "Audience up to 250,000",
    "Up to 50 employees",
    "Attribution required",
  ],
};

const licenseExpert = {
  key: "expert",
  name: "EXPERT",
  price: "$749",
  providedFeatures:
    licensePro.providedFeatures +
    [
      "audience_1m",
      "distribution_online",
      "distribution_podcast",
      "license_expert",
      "team_250",
    ],
  uses: ["PRO", "+", "Online advertising", "Podcasts", "Audio books"],
  conditions: [
    "Audience up to 1 million",
    "Up to 250 employees",
    "Attribution required",
  ],
};

const licenseMaster = {
  key: "master",
  name: "MASTER",
  price: "$1,499+",
  providedFeatures:
    licenseExpert.providedFeatures +
    [
      "audience_unlimited",
      "distribution_global",
      "distribution_remix",
      "license_master",
      "team_unlimited",
    ],
  contactUs: true,
  uses: ["EXPERT", "+", "Global media", "Worlwide advertising", "Re-mixes"],
  conditions: [
    "Unlimited audience",
    "Unlimited employees",
    "Attribution required",
  ],
};

const licenseCustom = {
  key: "custom",
  name: "CUSTOM",
  price: "Custom Quote",
  providedFeatures: ["license_custom"],
  contactUs: true,
  uses: [
    "MASTER",
    "+",
    "Access entire catalogue",
    "Original audio production",
    "Audio masters",
  ],
  conditions: ["Custom conditions", "Non-attribution", "Exclusive licenses"],
};

export const licenses = [
  licenseBasic,
  licensePro,
  licenseExpert,
  licenseMaster,
  licenseCustom,
];
